import Modal from 'bootstrap/js/dist/modal';
import 'lazysizes';

const body = document.querySelector('body');

// When the DOM is loaded, remove "preload"

document.addEventListener('DOMContentLoaded', function() {
  body.classList.remove('preload');
});

const mobileNavEl = document.getElementById('mobile-nav');

if (mobileNavEl) {
  const mobileNav = new Modal(mobileNavEl);
  const mobileBp = '1000px';
  let menuOpen = false;
  let bgLoaded = false;

  mobileNavEl.addEventListener('show.bs.modal', function (event) {
    menuOpen = true;
  })

  mobileNavEl.addEventListener('hide.bs.modal', function (event) {
    menuOpen = false;
  })

  // Preload the mobile nav background image
  function preloadBackgroundImage() {
    let preloadedImage = new Image();
    preloadedImage.src = "/dist/img/mobile-nav-bkg.jpg";
    bgLoaded = true;
  }

  // Create a condition that targets viewports at least 768px wide
  const mediaQuery = window.matchMedia(`(min-width: ${mobileBp})`);

  function handleMobileChange(e) {
    if (e.matches && menuOpen) {
      mobileNav.hide();
    }
    if (!e.matches && !bgLoaded) {
      preloadBackgroundImage();
    }
  }

  // Register event listener
  mediaQuery.addEventListener('change', handleMobileChange);

  // Initial check
  handleMobileChange(mediaQuery);
}

